import script from "./CategoryWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryWidget.vue?vue&type=script&setup=true&lang=js"

import "./CategoryWidget.vue?vue&type=style&index=0&id=9503a73e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9503a73e"]])

export default __exports__